import React from "react"

import amare_logo from "../../images/amare_logo.png"
import img_plate from "../../images/amare_img_3_h.jpg"
import img_ed_1 from "../../images/amare_img_12_v.jpg"
import img_ed_2 from "../../images/amare_img_19_v.jpg"
import img_feito from "../../images/amare_img_25_h.jpg"
import img_bases from "../../images/amare_img_33_h.jpg"
import img_exclusivas from "../../images/amare_img_28_h.jpg"

import * as amareStyles from "./amare.module.css"

/*
 * One reveal preset for the whole section. The handoff asks for a single
 * restrained fade-and-rise rather than the mix of slide-lefts this page used
 * before, so the props are built in one place instead of being repeated on a
 * dozen elements.
 */
const reveal = (delay = 0) => ({
  "data-sal": "slide-up",
  "data-sal-delay": delay,
  "data-sal-easing": "ease-out-circ",
  "data-sal-duration": 1200,
})

/*
 * Amaré — the last stop on the one-pager, and what /amare/ still renders.
 *
 * The lockup is the section's heading: an h2 whose text is the studio's name,
 * carried by the mark's alt text.
 */
export default function Amare() {
  return (
    <section id="amare" className={amareStyles.page}>
      <div className={amareStyles.wrap}>
        <h2 className={amareStyles.logo} {...reveal()}>
          <img src={amare_logo} alt="Amaré Design" />
        </h2>

        <div className={amareStyles.intro}>
          <p {...reveal()}>
            <span className={amareStyles.open}>O sertão virou mar!</span>{" "}
            Nosso estúdio de estamparia possui foco direcionado para a{" "}
            <em>produção sob demanda</em>, alinhando-se com princípios
            sustentáveis, reduzindo o desperdício - tanto para a nossa
            fábrica, quanto para o nosso cliente.
          </p>
          <p {...reveal(200)}>
            Atendemos não apenas aos grandes players da indústria da{" "}
            <em>moda do Ceará</em>, mas também clientes menores que buscam
            opções personalizadas.
          </p>
        </div>

        <div className={amareStyles.editorial}>
          <div
            className={`${amareStyles.edRow} ${amareStyles.edRowPlated}`}
            {...reveal()}
          >
            <figure className={amareStyles.edMedia}>
              <img src={img_ed_1} alt="Amaré" />
            </figure>
            <div className={amareStyles.edText}>
              {/* Above the paragraph, in its own column. Its own 3:2 rather
                  than the 4/5 crop the portrait media beside it takes. */}
              <figure className={amareStyles.edPlate}>
                <img src={img_plate} alt="Amaré" />
              </figure>
              <p>
                Ao minimizar a produção com a impressão de tecidos em demanda,
                e adotando <em>tecnologias avançadas</em>, a Amaré se torna
                mais eficiente e flexível, permitindo a criação de peças
                únicas e exclusivas de acordo com as preferências dos nossos
                clientes.
              </p>
            </div>
          </div>
          <div
            className={`${amareStyles.edRow} ${amareStyles.flip}`}
            {...reveal()}
          >
            <figure className={amareStyles.edMedia}>
              <img src={img_ed_2} alt="Amaré" />
            </figure>
            <div className={amareStyles.edText}>
              <p>
                Isso reduz não apenas o <em>impacto ambiental</em>, mas também
                promove uma <em>moda mais consciente</em>, onde o cliente tem
                um papel ativo na criação de sua estampa exclusiva, eliminando
                o excesso de estoque e{" "}
                <em>celebrando a individualidade de cada marca</em>.
              </p>
            </div>
          </div>
        </div>

        {/* Reveals sit on the individual panels, not on this grid. The grid
            is ~2760px tall on a phone, so a single reveal would finish
            animating while only its first panel was on screen. */}
        <div className={amareStyles.blocks}>
          <article
            className={`${amareStyles.ablock} ${amareStyles.pink} ${amareStyles.feitoText}`}
            {...reveal()}
          >
            <h3>Feito à mão</h3>
            <p>
              A Amaré abraça a fusão entre arte e tecnologia, incorporando
              técnicas de pintura à mão, como a aquarela, para criar estampas
              únicas e inspiradoras, que ganham ainda mais vida quando
              digitalizadas para impressão digital. Essa junção entre o
              artesanal e o digital abre portas para a criação de estampas que
              são verdadeiras obras de arte, elevando as estampas que
              entregamos aos nossos clientes.
            </p>
          </article>
          <figure
            className={`${amareStyles.ablock} ${amareStyles.media} ${amareStyles.feitoMedia}`}
            {...reveal()}
          >
            <img src={img_feito} alt="Amaré" />
          </figure>

          <figure
            className={`${amareStyles.ablock} ${amareStyles.media} ${amareStyles.basesMedia}`}
            {...reveal()}
          >
            <img src={img_bases} alt="Amaré" />
          </figure>
          <article
            className={`${amareStyles.ablock} ${amareStyles.green} ${amareStyles.basesText}`}
            {...reveal()}
          >
            <h3>Bases diversas</h3>
            <p>
              A estamparia oferece um grande leque de possibilidades por meio
              da ampla variedade tecidos disponíveis para a impressão. Com uma
              variedade que abrange entre bases de algodão, viscose, linho e
              muitas outras, bem como tecidos planos e malhas, nossos tecidos
              de diversas gramaturas podem ser usados para diversas
              finalidades - da moda praia à alfaiataria, atendemos às
              necessidades mais exigentes da indústria da moda.
            </p>
          </article>

          <article
            className={`${amareStyles.ablock} ${amareStyles.apricot} ${amareStyles.exclusivasText}`}
            {...reveal()}
          >
            <h3>Estampas exclusivas</h3>
            <p>
              Nossa estamparia se orgulha em oferecer a exclusividade de
              estampas, criando designs sob medida para nossos clientes.
              Inspirados pelas cores vibrantes e rica cultura do Nordeste,
              nossos designers fundadores possuem experiências de Nova York,
              trazendo uma perspectiva global e criatividade inovadora para
              cada projeto. Essa colaboração única resulta em estampas que são
              verdadeiramente distintas, incorporando a essência do Nordeste
              com uma pitada de influência cosmopolita.
            </p>
          </article>
          <figure
            className={`${amareStyles.ablock} ${amareStyles.media} ${amareStyles.exclusivasMedia}`}
            {...reveal()}
          >
            <img src={img_exclusivas} alt="Amaré" />
          </figure>
        </div>

        <div className={amareStyles.close} {...reveal()}>
          <p>
            Cada estampa é uma narrativa única, uma expressão de identidade e
            um reflexo das experiências pessoais dos nossos designers e dos
            nossos clientes.
          </p>
        </div>
      </div>
    </section>
  )
}
